import { useMemo } from "react";

function useFilters({ isPrivate, data }: any) {
  const dist = useMemo(() => {
    const dist = {
      approved: [] as any,
      rejected: [] as any,
      pending: [] as any,
    };

    if (!isPrivate) return dist;

    data?.people?.collection?.forEach((p: any) => {
      switch (p.status?.toLowerCase()) {
        case "rejected":
          dist.rejected.push(p);
          break;
        case "approved":
          dist.approved.push(p);
          break;
        case "pending":
        default:
          dist.pending.push(p);
          break;
      }
    });

    return dist;
  }, [data, isPrivate]);

  return { people: data?.people?.collection, dist: dist };
}
export { useFilters };
